import { Button, Image, Text } from "@primitives";
import React from "react";

import { Carousel, Dots, useCarousel } from "@ui/Carousel";

const FadeCarousel = () => {
  const { nextButtonProps, previousButtonProps, dotProps, carouselProps } =
    useCarousel({
      loop: true,
      watchDrag: true,
      autoPlay: false,
    });

  return (
    <div className="main-column">
      <div className="flex flex-col gap-3">
        <Carousel
          {...carouselProps}
          fade
          aspectRatioStyles="aspect-ratio-[1.77]"
        >
          <Image
            alt="placeholder image"
            src="/images/dummy/placeholder_1.png"
          />
          <Image
            alt="placeholder image"
            src="/images/dummy/placeholder_2.png"
          />
          <Image
            alt="placeholder image"
            src="/images/dummy/placeholder_3.png"
          />
        </Carousel>
        <Dots {...dotProps} />
        <div className="flex flex-row gap-3">
          <Button
            {...previousButtonProps}
            ariaLabel="Click to go to previous slide"
          >
            Previous
          </Button>
          <Button {...nextButtonProps} ariaLabel="Click to go to next slide">
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

const SlidesCarousel = () => {
  const { nextButtonProps, previousButtonProps, dotProps, carouselProps } =
    useCarousel({
      dragFree: true,
      watchDrag: true,
    });

  return (
    <div>
      <Carousel {...carouselProps} mainColumn>
        <Image
          alt="placeholder image"
          src="/images/dummy/placeholder_1.png"
          className="h-[400px]"
        />
        <Image
          alt="placeholder image"
          src="/images/dummy/placeholder_2.png"
          className="h-[400px]"
        />
        <Image
          alt="placeholder image"
          src="/images/dummy/placeholder_3.png"
          className="h-[400px]"
        />
        <Image
          alt="placeholder image"
          src="/images/dummy/placeholder_1.png"
          className="h-[400px]"
        />
        <Image
          alt="placeholder image"
          src="/images/dummy/placeholder_2.png"
          className="h-[400px]"
        />
        <Image
          alt="placeholder image"
          src="/images/dummy/placeholder_3.png"
          className="h-[400px]"
        />
      </Carousel>

      <div className="mt-[20px] main-column ">
        <Dots {...dotProps} />

        <div className="mt-[20px] flex flex-row gap-3">
          <Button
            {...previousButtonProps}
            ariaLabel="Click to go to previous slide"
          >
            Previous
          </Button>
          <Button {...nextButtonProps} ariaLabel="Click to go to next slide">
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

const EmblaCarouselEg = () => {
  return (
    <div>
      <div className="flex flex-col gap-3">
        <Text as="h3">fade carousel</Text>
        <FadeCarousel />
        <Text as="h3">slides carousel</Text>
        <SlidesCarousel />
      </div>
    </div>
  );
};

export default EmblaCarouselEg;
